// =============================================================================
// FEATURES SECTION COMPONENT
// =============================================================================

import React from 'react';
import { ServiceIcon } from '@/components/ServiceIcon';
import type { ContentComponent } from '@/types';

interface FeaturesSectionProps {
  component: ContentComponent;
}

/**
 * Features Section Component
 */
export const FeaturesSection: React.FC<FeaturesSectionProps> = ({ component }) => {
  return <FeaturesSectionImpl component={component} />;
};

/**
 * Features Section Implementation
 */
const FeaturesSectionImpl: React.FC<{ component: ContentComponent }> = ({ component }) => {
  const { id, title, content, metadata } = component;
  
  const features = metadata?.features || [];
  const columns = metadata?.columns || 3;
  
  return (
    <section id={id} className="content-section features-section">
      <div className="container">
        {title && (
          <div className="section-header">
            <h2 className="heading-style">{title}</h2>
            {content && <p className="body-style">{content}</p>}
          </div>
        )}
        
        <div className={`grid grid-cols-${columns}`}>
          {features.map((feature: any, index: number) => (
            <div key={index} className="feature-item">
              <div className="feature-icon">
                <ServiceIcon
                  icon={feature.icon || 'fi-ts-leadership'}
                  alt={`${feature.title} - ${feature.description}`}
                  title={feature.title}
                  size="lg"
                  className="feature-service-icon"
                />
              </div>
              <h3 className="heading-style">{feature.title}</h3>
              <p className="body-style">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { FeaturesSectionImpl };

